import styled from "styled-components";
export default styled.div(["margin:0 auto;max-width:994px;padding:0 32px;@media (max-width:650px){padding:0 10px 20px;}"]);